var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37603 17.2339V16.9602C4.41619 16.1503 4.67575 15.3656 5.12794 14.687C5.88063 13.8718 6.39588 12.8729 6.61964 11.795C6.61964 10.9619 6.61964 10.1169 6.69241 9.28378C7.06836 5.27302 11.0341 2.5 14.9513 2.5H15.0483C18.9656 2.5 22.9313 5.27302 23.3194 9.28378C23.3922 10.1169 23.3194 10.9619 23.38 11.795C23.6068 12.8754 24.1215 13.8774 24.8717 14.6989C25.3273 15.3715 25.5873 16.1533 25.6236 16.9602V17.222C25.6507 18.3101 25.276 19.371 24.5685 20.2092C23.6337 21.1893 22.3651 21.7991 21.003 21.923C17.0087 22.3515 12.9788 22.3515 8.98453 21.923C7.62393 21.7937 6.3572 21.1849 5.41901 20.2092C4.7225 19.3704 4.3528 18.3157 4.37603 17.2339Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9437 26.0647C12.5678 26.8481 13.4843 27.355 14.4903 27.4734C15.4964 27.5918 16.509 27.3118 17.3041 26.6955C17.5487 26.5132 17.7687 26.3013 17.959 26.0647",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 9.25C23.877 9.25 25.5 7.62703 25.5 5.625C25.5 3.62297 23.877 2 21.875 2C19.873 2 18.25 3.62297 18.25 5.625C18.25 7.62703 19.873 9.25 21.875 9.25Z",
    fill: "#FF4D4F",
    stroke: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNew);
export default __webpack_public_path__ + "static/media/notification-new.743d689bd18b5c311402b82e9cd1d55b.svg";
export { ForwardRef as ReactComponent };